const $$splitComponentImporter = () => import('/home/runner/work/inspecttec-frontend-admin/inspecttec-frontend-admin/src/routes/client/users/create.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { Permissions } from "@/constants/permissions";
import { requirePermission } from "@/lib/auth/permission-guard";
import { createFileRoute } from "@tanstack/react-router";
import * as z from "zod";

// Access comes from group membership (founder, 2026-09-26): every user joins at least one
// group, and the backend refuses a user without one.
const userSchema = z.object({
  firstName: z.string().min(1, "First name is required"),
  lastName: z.string().min(1, "Last name is required"),
  email: z.string().min(1, "Email is required").email("Invalid email address"),
  isActive: z.boolean(),
  groupIds: z.array(z.string()).min(1, "Pick at least one group. Their groups decide what they can do.")
});
type UserFormValues = z.infer<typeof userSchema>;
export const Route = createFileRoute("/client/users/create")({
  beforeLoad: args => requirePermission(Permissions.ClientUsers.Create, args),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});